<template>
  <div class="main-container">
    <div class="page-top-title">
      <p class="title">{{ reportName }}</p>
      <div class="page-top-right">
        <div class="item">
          结算周期：
          <span class="num">{{ settlementDate }}</span>
        </div>
        <div class="item settlement-status">
          结算状态：
          <div v-if="detailData.settlementStatus == 0" class="tag-settled">未结算</div>
          <div v-else class="tag-be">已结算</div>
        </div>
      </div>
    </div>
    <div class="statistics-container">
      <p>汇总数据</p>
      <div class="statistics-item">
        <div class="item">
          保单数：
          <span class="num">{{ statisticsObj.policyNum || 0 }}</span>
          单
        </div>
        <div class="item">
          保费：
          <span class="num">{{ statisticsObj.fee || 0 }}</span
          >元
        </div>
        <div class="item">
          费用合计：
          <span class="num">{{ statisticsObj.income || 0 }}</span
          >元
        </div>
        <div class="item">
          首期净收入：
          <span class="num">{{ statisticsObj.firstIncome || 0 }}</span
          >元
        </div>
        <div class="item">
          续期净收入：
          <span class="num">{{ statisticsObj.renewalIncome || 0 }}</span
          >元
        </div>
        <div class="item">
          首年后置费用净收入：
          <span class="num">{{ statisticsObj.postfIncome || 0 }}</span
          >元
        </div>
      </div>
    </div>

    <loading :isShow="listLoading" />
    <div class="table-box">
      <Table ref="table" :columns="columns" :data="tableData">
        <template slot-scope="{ row }" slot="userName_staffNo">
          <div class="name-status">
            <div class="user-box">
              <i class="dian" :class="{ red: row.workingState == 0, orange: row.isSus == 1 }" v-if="row.userName"></i>
              <span class="user-name">{{ row.staffNo }}</span>
              <span v-if="row.staffNo">/</span>
              <span class="user-name">{{ row.userName }}</span>
            </div>
          </div>
        </template>

        <template slot-scope="{ row }" slot="recommendName_staffNo">
          <div class="name-status">
            <div class="user-box">
              <i class="dian" :class="{ red: row.recommendWorkingState == 0, orange: row.recommendIsSus == 1 }" v-if="row.recommendName"></i>
              <span class="user-name">{{ row.recommendStaffNo }}</span>
              <span v-if="row.recommendStaffNo">/</span>
              <span class="user-name">{{ row.recommendName }}</span>
            </div>
          </div>
        </template>

        <template slot-scope="{ row }" slot="breedName_staffNo">
          <div class="name-status">
            <div class="user-box">
              <i class="dian" :class="{ red: row.breedWorkingState == 0, orange: row.breedIsSus == 1 }" v-if="row.breedName"></i>
              <span class="user-name">{{ row.breedStaffNo }}</span>
              <span v-if="row.breedStaffNo">/</span>
              <span class="user-name">{{ row.breedName }}</span>
            </div>
          </div>
        </template>

        <template slot-scope="{ row }" slot="groupLeaderName_staffNo">
          <div class="name-status">
            <div class="user-box">
              <i class="dian" :class="{ red: row.groupLeaderWorkingState == 0, orange: row.groupLeaderIsSus == 1 }" v-if="row.groupLeaderName"></i>
              <span class="user-name">{{ row.groupLeaderStaffNo }}</span>
              <span v-if="row.groupLeaderStaffNo">/</span>
              <span class="user-name">{{ row.groupLeaderName }}</span>
            </div>
          </div>
        </template>

        <template slot-scope="{ row }" slot="action">
          <span class="table-btn" @click="detailsPage(row)">明细</span>
        </template>
      </Table>
    </div>
    <Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center; margin-top: 20px" />

    <div>
      <Button class="btn" @click="back('/orgSettlement/commissionSettlement')">返回</Button>
      <Button class="btn" @click="backOperate" v-if="detailData.settlementStatus == 0 && userInfo.userType !=3">上一步</Button>
      <Button class="btn" @click="settledStep" v-if="detailData.settlementStatus == 1 && userInfo.userType !=3">上一步</Button>
      <Button class="btn" @click="exportReport">导出报表</Button>
      <Button type="primary" class="btn" @click="settlement" v-if="detailData.settlementStatus == 0 && userInfo.userType !=3">结算</Button>
      <Button type="primary" class="btn" v-else-if="detailData.settlementStatus != 0 && userInfo.userType !=3" @click="resettlement">撤回结算</Button>

      <Button type="primary" class="btn" v-show="detailData.settlementStatus == 1 && detailData.payStatus == 0 && userInfo.userType !=3" @click="payment(detailData.payStatus)"
        >付款</Button
      >
      <Button type="primary" class="btn" v-show="detailData.settlementStatus == 1 && detailData.payStatus == 1 && userInfo.userType !=3" @click="payment(detailData.payStatus)"
        >取消付款</Button
      >
      <Button type="primary" :disabled="detailData.settlementStatus == 0 ? true : false" v-if="detailData.settlementStatus == 0 && userInfo.userType !=3">付款</Button>
    </div>
    <payPopUp ref="payPopUpRef" @change-pay="getDetailData"></payPopUp>
  </div>
</template>

<script>
import { common, pageTool } from '@/api/mixins';
import payPopUp from '../components/payPopUp';
import { mapState } from "vuex";

export default {
  mixins: [common, pageTool],
  components: { payPopUp },
  props: {
    backData: {
      type: Object,
      default: {}
    }
  },
  computed: {
    ...mapState(["userInfo"])
  },
  data() {
    return {
      reportId: null,
      settlementStatus: null,
      step: null,
      reportName: '',
      settlementDate: '',
      statisticsObj: {},
      detailData: {},
      tableData: [],
      total: 0,
      columns: [
        {
          title: '机构',
          align: 'center',
          key: 'orgName',
          minWidth: 200
        },
        {
          title: '保单数',
          align: 'center',
          key: 'policyNum',
          minWidth: 120
        },
        {
          title: '保费',
          align: 'center',
          key: 'fee',
          minWidth: 100
        },
        {
          title: '费用合计',
          align: 'center',
          key: 'income',
          minWidth: 100
        },
        {
          title: '首期净收入',
          align: 'center',
          key: 'firstIncome',
          minWidth: 100
        },
        {
          title: '续期净收入',
          align: 'center',
          key: 'renewalIncome',
          minWidth: 160
        },
        {
          title: '首年后置费用净收入',
          align: 'center',
          key: 'postfIncome',
          minWidth: 100
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center',
          width: 80,
          fixed: 'right'
        }
      ]
    };
  },
  created() {
    const { reportId, settlementDate, reportName, step } = this.$route.query;
    this.reportId = reportId;
    this.reportName = reportName;
    this.settlementDate = settlementDate;
    this.step = step;
  },
  activated() {
    if (this.reportId) {
      this.pageNum = 1;
      this.getList();
      this.getStatisticsData();
      this.getDetailData();
    }
  },
  methods: {
    setData() {
      const { reportId, settlementDate, reportName } = this.backData;
      this.reportId = reportId;
      this.reportName = reportName;
      this.settlementDate = settlementDate;
      this.pageNum = 1;
      this.getList();
      this.getStatisticsData();
      this.getDetailData();
    },

    // 获取详情
    getDetailData() {
      this.$http({
        url: '/buz/settlementReport/read/detail',
        type: 'GET',
        data: {
          id: this.reportId
        }
      }).then(res => {
        this.detailData = res.data;
      });
    },

    // 统计
    getStatisticsData() {
      this.$http({
        url: '/buz/settlementDetails/statistics',
        type: 'POST',
        data: {
          reportId: this.reportId
        }
      }).then(res => {
        if (res.data) {
          this.statisticsObj = res.data;
        }
      });
    },

    getList() {
      this.listLoading = true;
      this.$http({
        url: '/buz/settlementDetails/read/page',
        type: 'POST',
        data: {
          reportId: this.reportId,
          pageNo: this.pageNum,
          pageSize: this.pageSize
        }
      })
        .then(res => {
          this.tableData = res.data;
          this.total = res.total;
          this.listLoading = false;
        })
        .catch(e => {
          this.listLoading = false;
        });
    },

    //  详情
    detailsPage(row) {
      this.openPageTabTags('/orgSettlement/commissionSettlement/detail', {
        reportId: this.reportId,
        orgId: row.orgId,
        title: `${row.orgCode}/${row.orgName}${this.settlementDate}基础费用结算明细`
      });
    },

    // 上一步
    backOperate() {
      if (!this.$units.pointAction('offline_82_2_1')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      this.$http({
        url: '/buz/settlementDetails/rollback',
        type: 'POST',
        data: {
          reportId: this.reportId
        }
      }).then(res => {
        this.$emit('backPage', { reportId: this.reportId, isAdd: 0, settled: false });
      });
    },

    // 已结算上一步
    settledStep() {
      this.$emit('settledStep', { reportId: this.reportId, isAdd: 0, settled: true });
    },

    // 导出
    exportReport() {
      if (!this.$units.pointAction('offline_82_2_4')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      this.$units.downloadFile('/buz/settlementDetails/export', { reportId: this.reportId }, 'POST');
    },

    // 结算
    settlement() {
      if (!this.$units.pointAction('offline_82_2_1')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      this.$notice.inquiry('结算后下级机构即可登录查看已结算清单，请确认是否结算?').then(() => {
        this.$http({
          url: '/buz/settlementReport/settlement',
          type: 'POST',
          data: {
            id: this.reportId
          }
        }).then(res => {
          this.getList();
          this.getDetailData();
          this.$notice.success('结算成功');
        });
      });
    },

    // 撤回结算
    resettlement() {
      if (!this.$units.pointAction('offline_82_2_1')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      this.$notice.inquiry('您确定撤回结算吗?').then(() => {
        this.$http({
          url: '/buz/settlementReport/resettlement',
          type: 'POST',
          data: {
            id: this.reportId
          }
        }).then(res => {
          this.getList();
          this.getDetailData();
          this.$notice.success('撤回成功');
        });
      });
    },

    payment(payStatus) {
      if (!this.$units.pointAction('offline_82_2_6')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      this.$refs.payPopUpRef.open(payStatus, this.reportId);
    }
  }
};
</script>

<style lang="scss" scoped>
.page-top-title {
  font-size: 15px;
  display: flex;
  .title {
    font-size: 16px;
    color: #3c464f;
    font-weight: bold;
  }
  .page-top-right {
    display: flex;
    align-items: center;
    margin-left: auto;
    .item {
      color: #515c6f;
      font-size: 14px;
      margin-left: 20px;
    }
    .settlement-status {
      margin-top: 1px;
      margin-left: 20px;
      display: flex;
      .tag-settled {
        width: 55px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        border-radius: 2px;
        font-size: 13px;
        color: #e3461f;
        border: 1px solid #ffc1b2;
        background: #fff5f2;
      }
      .tag-be {
        width: 55px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        border-radius: 4px;
        font-size: 13px;
        color: #35bf3f;
        border: 1px solid #abeaae;
        background: #f6fcf4;
      }
    }
  }
}
.statistics-container {
  margin-top: 20px;
  display: flex;
  p {
    white-space: nowrap;
  }
  .statistics-item {
    margin-left: 20px;
    display: flex;
    flex-wrap: wrap;
    color: #333;

    .item {
      font-weight: bold;
      white-space: nowrap;
      margin-bottom: 10px;
      width: 300px;
      .num {
        color: #ff7134;
      }

      .label {
        position: relative;

        .tip-icon {
          margin-right: 2px;
          width: 15px;
          height: 15px;
          border-radius: 15px;
          background: transparent;
          border: 1px solid #9c9c9c;
          color: #a8a6a6;
          display: inline-block;
          text-align: center;
          line-height: 14px;
          font-size: 14px;
          cursor: pointer;
          top: 50%;
        }

        .tip-icon:hover + .pop-tip {
          opacity: 0.9;
          z-index: 9999;
          display: block;
        }

        .pop-tip {
          position: absolute;
          width: 250px;
          top: -42px;
          display: flex;
          align-items: center;
          text-align: left;
          left: 50%;
          margin-left: -90px;
          padding: 6px 10px;
          display: flex;
          flex-direction: column;
          background-color: #444444;
          display: none;
          border-radius: 4px;

          span {
            font-size: 12px;
            font-weight: 500;
            color: #fff;
          }

          .arrow {
            position: absolute;
            width: 12px;
            height: 12px;
            background-color: #444444;
            opacity: 0.9;
            bottom: -4px;
            left: 74px;
            transform: rotateZ(135deg);
          }
        }
      }
    }
  }
}
.name-status {
  align-items: center;
  /deep/ .user-box {
    font-size: 12px;
    .dian {
      display: inline-block;
      flex-shrink: 0;
      width: 5px;
      height: 5px;
      background: #35bf3f;
      border-radius: 50%;
      margin-right: 4px;
      &.red {
        background: #e3461f;
      }
      &.orange {
        background: #ff9900 !important;
      }
    }
    &.text {
      color: #515c6f;
    }
    .user-name {
      font-size: 13px;
      &.dashed {
        border-bottom: 1px dashed #236dff;
      }
      &.line {
        border-bottom: 1px solid #236dff;
      }
    }
    i {
      color: #bababa;
      font-size: 13px;
    }
    .iconduichang {
      margin-left: 4px;
    }
    &.no-token {
      color: #515c6f;
      .user-name {
        cursor: auto;
      }
    }
  }
}
</style>
